<template>
  <div>
    <h2 class="font-semibold">
      {{ project.name }}
      <fa-icon
        :icon="['fal', 'pencil']"
        class="cursor-pointer text-gray-600"
        @click="$emit('edit')"
      />
    </h2>
    <div class="flex items-center justify-between w-full py-2 px-2 bg-gray-200 my-3 rounded text-gray-700 tracking-wider">
      <span
        v-if="isShown"
        class="w-4/5 truncate"
      >
        {{ project.apiKey }}
      </span>
      <span v-else>•••••••••••••••••••••••••••••••••••</span>
      <span>
        <fa-icon
          v-tooltip="isShown ? $t('project.hide', 'Hide') : $t('project.show', 'Show')"
          class="cursor-pointer mr-2"
          :icon="['fal', isShown ? 'eye-slash' :'eye']"
          @click="isShown = !isShown"
        />
        <fa-icon
          v-tooltip="$t('Copy to clipboard', 'Copy to clipboard')"
          class="cursor-pointer mr-2"
          :icon="['fal', 'copy']"
          @click="copy"
        />
        <fa-icon
          v-tooltip="$t('project.delete', 'Delete api key')"
          class="cursor-pointer mr-2"
          :icon="['fal', 'trash']"
          @click="deleteToken"
        />
      </span>
    </div>
  </div>
</template>

<script>
import { actionNames } from '@/store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCopy, faTrash, faEye, faEyeSlash, faPencil } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faCopy, faTrash, faEye, faEyeSlash, faPencil)
export default {
  name: 'ProjectBox',
  components: {
    'fa-icon': FontAwesomeIcon
  },
  props: {
    project: { type: Object, default: () => {} }
  },
  data () {
    return {
      isShown: false
    }
  },
  methods: {
    async copy () {
      try {
        await this.$copyText(this.project.apiKey)
        this.$toast.info(this.$t('Api key copied to clipboard', 'Api key copied to clipboard'))
      } catch (e) {
        console.error('Could not copy: ' + e.message)
      }
    },
    async deleteToken () {
      const accepted = await this.$swal('warning', {
        title: this.$t('warning', 'Warning') + '!',
        text: this.$t('projects.deletewarning', 'You are about to delete an Project. If you proceed, your applications using this key could not access the api in the future.'),
        icon: 'error',
        dangerMode: true,
        buttons: true
      })
      if (!accepted) {
        return
      }
      await this.$store.dispatch(actionNames.DELETE_PROJECT, this.project.id)
    }
  }
}
</script>
